import { LinearProgress } from '@mui/material';
import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Help from '../Screens/Help/help';
import Page404 from '../Screens/Page404';

const Landing = lazy(() => import('../Screens/Landing'));

const AppNavigation = () => {
  return (
    <>
      <Suspense fallback={<LinearProgress />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/help" element={<Help />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default AppNavigation;
